import { render, staticRenderFns } from "./comoPatrocinar.vue?vue&type=template&id=4703066b&"
import script from "./comoPatrocinar.vue?vue&type=script&lang=js&"
export * from "./comoPatrocinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports